import { render, staticRenderFns } from "./TouchScreen.vue?vue&type=template&id=5ce3e969&scoped=true&"
import script from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js&"
export * from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./TouchScreen.vue?vue&type=style&index=0&id=5ce3e969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce3e969",
  null
  
)

export default component.exports